import {Box, FormControl, InputLabel, Select, TextField, Typography, RadioGroup, Grid} from '@mui/material'
import {styled} from '@mui/material/styles'

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
}))

export const StyledBoxContainer = styled(StyledBox)(() => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center'
}))

export const StyledLabel = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 500,
  color: theme.palette.common.black,
  marginBottom: '4px',
  display: 'flex',
  alignItems: 'center'
}))

export const StyledFormControl = styled(FormControl)(({theme}) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.common.white,
    fontSize: '16px'
  }
}))

export const StyledTextField = styled(TextField)(({theme}) => ({
  width: '100%',
  backgroundColor: theme.palette.common.white,
  fontSize: '16px',
  '& .MuiOutlinedInput-root': {
    fontSize: '16px'
  }
}))

export const StyledSelect = styled(Select)(({theme}) => ({
  backgroundColor: theme.palette.common.white,
  fontSize: '14px'
}))

export const StyledRadioGroup = styled(RadioGroup)(() => ({
  flexDirection: 'row'
}))

export const StyledErrorBox = styled(Box)(() => ({
  marginTop: '8px',
  justifyContent: 'flex-start',
  display: 'flex'
}))

export const StyledErrorInputLabel = styled(InputLabel)(() => ({
  fontSize: '12px',
  color: 'red',
  fontWeight: 500
}))

export const StyledTopGrid = styled(Grid)(() => ({
  paddingX: '20px'
}))

export const StyledBottomGrid = styled(StyledTopGrid)(() => ({
  marginTop: '10px'
}))
